import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CustomFile } from '@common/models/custom-file';
import { UploadFilesService } from '@customer/itsm/upload-files/upload-files.service';

@Component({
    selector: 'aa-upload-file-displayer',
    templateUrl: './upload-file-displayer.component.html',
    styleUrls: [
        './upload-file-displayer.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploadFileDisplayerComponent
{
    @Input() file: CustomFile;
    canRemove: boolean = true;
    swpercent: number = 0;
    status: string = 'current';

    constructor (
        private uploadFilesService: UploadFilesService
    )
    { }

    removeFile ()
    {
        this.uploadFilesService.removeFile(this.file.id);
    }
}
